import { v4 as uuidv4 } from "uuid";
import store from "@/store";

/**
 * @deprecated
 */
export const NotificationStoreModule = {
  name: "notification",
  namespaced: true,

  state: {
    id: "",
    show: true,
    text: "",
    color: "",
    timeout: "",
  },

  mutations: {
    SHOW_MESSAGE(state, payload) {
      state.id = uuidv4();
      state.text = payload.text;
      state.color = payload.color;
      state.timeout = payload.timeout;
    },
  },
};

/**
 * @deprecated
 */
export const NotificationPlugin = {
  install(vue) {
    vue.prototype.$notify = {
      /**
       * @param {String} text
       * @param {NotificationType} type
       * @param {number} timeout
       * @deprecated
       */
      showMessage(text, type, timeout = 5) {
        store.commit("notification/SHOW_MESSAGE", {
          text,
          color: type,
          timeout: timeout * 1000,
        });
      },
    };
  },
};
